// src/pages/LoginPage.js
import React from 'react';
import LoginLayout from '../components/LoginLayout';
// import LoginLogo from '../components/LoginLogo';
import LoginPageUI from '../components/LoginUI'; // Using the UI-only form

const LoginPage = () => {
  return (
    <LoginLayout>
      {/* <LoginLogo /> */}
      <LoginPageUI/>
    </LoginLayout>
  );
};

export default LoginPage;